export const selectIsNPSVisible = (state) =>
  state.loggedUserInfo?.info?.data?.user?.nps;
